export default "/_next/static/images/checkmark-c322e619eeb9b7c09987bc74072de6dd.svg";